document.addEventListener("DOMContentLoaded", async () => {

    const modal = document.getElementById('edit-preferences-modal');
    if (!modal) return;

    loadZxcvbn();


    const emailElements = {
        current: document.getElementById('currentEmail'),
        new: document.getElementById('newEmail'),
        confirm: document.getElementById('confirmEmail'),
        password: document.getElementById('currentPasswordToChangeEmail'),
        saveBtn: document.getElementById('saveEmailButton')
    };


    const passwordElements = {
        current: document.getElementById('currentPassword'),
        new: document.getElementById('newPassword'),
        confirm: document.getElementById('confirmPassword'),
        saveBtn: document.getElementById('savePasswordButton')
    };


    const updateButtonState = (button, isValid) => {
        button.disabled = !isValid;
    };

    const resetFields = (...fields) => {
        fields.forEach(field => {
            field.value = '';
            field.classList.remove('is-invalid', 'is-valid');
            if (field.nextElementSibling) {
                field.nextElementSibling.textContent = '';
            }
        });
    };


    const setupEmailEvents = () => {
        const validateEmailFields = async () => {
            const isEmailValid = await devtricker_process_account_validateNewEmail();
            const isConfirmValid = devtricker_process_account_validateConfirmEmail();
            const hasPassword = devtricker_account_hasPasswordToChangeEmail();
            updateButtonState(emailElements.saveBtn, isEmailValid && isConfirmValid && hasPassword);
        };

        emailElements.new.addEventListener('input', validateEmailFields);
        emailElements.confirm.addEventListener('input', validateEmailFields);
        emailElements.password.addEventListener('input', validateEmailFields);
    };


    const setupPasswordEvents = () => {
        const validatePasswordFields = () => {
            const isValid = passwordElements.new.classList.contains('is-valid') &&
                devtricker_process_account_validateConfirmPassword() &&
                devtricker_process_account_validateCurrentPassword();
            updateButtonState(passwordElements.saveBtn, isValid);
        };

        passwordElements.new.addEventListener('input', () => {
            devtricker_process_account_validateNewPassword();
            validatePasswordFields();
        });

        passwordElements.confirm.addEventListener('input', validatePasswordFields);
        passwordElements.current.addEventListener('input', validatePasswordFields);
    };


    const handleSaveEmail = async () => {
        if (emailElements.saveBtn.disabled) return;

        emailElements.saveBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving...';

        try {
            const result = await devtricker_updateUserEmail(
                emailElements.new.value.trim(),
                emailElements.password.value
            );

            if (result.available) throw new Error(result.message);

            resetFields(emailElements.new, emailElements.confirm, emailElements.password);
            emailElements.current.value = emailElements.new.value.trim();
            emailElements.saveBtn.innerHTML = '<span class="fw-semibold">Email updated</span>';
            emailElements.saveBtn.disabled = true;
            devtricker_showUserSettingsModalToast(devtricker_createSuccessToast("Email updated.", 'top', 10));
        } catch (error) {
            emailElements.saveBtn.innerHTML = '<span class="fw-semibold">Save email</span>';
            devtricker_showUserSettingsModalToast(devtricker_createErrorToast('top', 10, error.message));
        }
    };


    const handleSavePassword = async (e) => {
        e.stopPropagation();
        if (passwordElements.saveBtn.disabled) return;

        passwordElements.saveBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving...';

        try {
            const result = await devtricker_updatePassword(
                passwordElements.current.value.trim(),
                passwordElements.new.value.trim(),
                g_devtricker_password_strength
            );

            if (!result.success) throw new Error(result.message);

            passwordElements.saveBtn.innerHTML = '<span class="fw-semibold">Password updated</span>';
            passwordElements.saveBtn.disabled = true;
            resetFields(passwordElements.current, passwordElements.new, passwordElements.confirm);
            await devtricker_process_perform_logout();
        } catch (error) {
            passwordElements.saveBtn.innerHTML = '<span class="fw-semibold">Save password</span>';
            devtricker_showUserSettingsModalToast(devtricker_createErrorToast('top', 10, error.message));
        }
    };

    resetFields(
        emailElements.new, emailElements.confirm, emailElements.password,
        passwordElements.current, passwordElements.new, passwordElements.confirm
    );


    emailElements.current.value = await devtricker_fetch_user_email();
    emailElements.current.disabled = true;


    setupEmailEvents();
    setupPasswordEvents();


    if (!window.zxcvbn && !window.zxcvbnLoading) {
        window.zxcvbnLoading = true;
        const script = document.createElement('script');
        script.src = `${g_devtricker_Settings.siteUrl}/wp-includes/js/zxcvbn.min.js`;
        script.async = true;

        script.onload = () => {
            devtricker_log(null, devtricker_log_level.INFO, "zxcvbn library loaded");
            window.zxcvbnLoaded = true;
        };

        script.onerror = (error) => {
            devtricker_log(error, devtricker_log_level.ERROR, "zxcvbn failed to load");
        };

        document.head.appendChild(script);
    }



    emailElements.saveBtn.addEventListener('click', handleSaveEmail);
    passwordElements.saveBtn.addEventListener('click', handleSavePassword);


    const profileModal = document.getElementById('edit-profile-modal');
    if (!profileModal) return;


    const profile = {
        bio: document.getElementById('profileBio'),
        username: document.getElementById('profileArroba'),
        saveBtn: document.getElementById('saveProfileButton'),
        form: document.getElementById('editProfileForm'),
        inputs: {
            name: document.getElementById('profileName'),
            username: document.getElementById('profileArroba'),
            bio: document.getElementById('profileBio'),
            website: document.getElementById('profileWebsite'),
            linkedin: document.getElementById('profileLinkedin'),
            github: document.getElementById('profileGitHub')
        },
        image: {
            input: document.getElementById('profile-image-input'),
            preview: document.getElementById('edit-profile-img'),
            nav: document.querySelector(".user-avatar-nav"),
            label: document.getElementById("label-profile-image-input"),
            deleteBtn: document.getElementById("remove-profile-image")
        }
    };


    let usernameTimeout;
    if (profile.username) {
        profile.username.addEventListener('input', () => {
            profile.username.value = profile.username.value.toLowerCase();
            clearTimeout(usernameTimeout);
            usernameTimeout = setTimeout(() => devtricker_process_validateUsername_2(profile.username), 500);
        });
    }


    if (profile.bio) {
        profile.bio.addEventListener('input', () => {
            if (profile.bio.value.length > 160) {
                profile.bio.value = profile.bio.value.substring(0, 160);
            }
        });
    }


    const handleSaveProfile = async (e) => {
        e.preventDefault();
        profile.saveBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving...';

        try {
            const userId = document.getElementById('user-id').dataset.userId;
            const result = await devtricker_updateUserProfile(userId);

            if (result?.username) {
                window.location.href = `${window.location.origin}/@${result.username}`;
            }
        } catch (error) {
            profile.saveBtn.innerHTML = "<span>Save</span>";
            devtricker_showEditProfileModalToast(devtricker_createErrorToast('top', 10, error.message));
        }
    };


    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        profile.image.label.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Changing...';

        try {
            const newImageUrl = await devtricker_uploadUserProfileImage(file);
            [profile.image.preview, profile.image.nav].forEach(img => {
                if (img) {
                    img.src = newImageUrl;
                    if (img === profile.image.nav) img.srcset = newImageUrl;
                }
            });
        } catch (error) {
            console.error("Upload error:", error);
        } finally {
            profile.image.label.innerHTML = "Change";
        }
    };


    const handleRemoveImage = async () => {
        profile.image.deleteBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Removing...';

        try {
            await devtricker_removeUserProfileImage();
            const defaultImage = "https://media.devtricks.io/curated/profile_default.png";
            [profile.image.preview, profile.image.nav].forEach(img => {
                if (img) {
                    img.src = defaultImage;
                    if (img === profile.image.nav) img.srcset = defaultImage;
                }
            });
        } catch (error) {
            console.error("Remove error:", error);
        } finally {
            profile.image.deleteBtn.innerHTML = "Remove";
        }
    };


    if (profile.saveBtn) profile.saveBtn.addEventListener('click', handleSaveProfile);
    if (profile.image.input) profile.image.input.addEventListener('change', handleImageUpload);
    if (profile.image.deleteBtn) profile.image.deleteBtn.addEventListener('click', handleRemoveImage);
});






const loadZxcvbn = () => {
    if (window.zxcvbn) {
        return;
    }

    if (window.zxcvbnLoading) {
        return;
    }

    window.zxcvbnLoading = true;

    const script = document.createElement('script');
    script.src = `${g_devtricker_Settings.siteUrl}/wp-includes/js/zxcvbn.min.js`;
    script.async = true;

    script.onload = () => {
        if (!window.zxcvbn) {
            devtricker_log(null, devtricker_log_level.ERROR, "zxcvbn não definido após carregamento");
        } else {
            devtricker_log(null, devtricker_log_level.INFO, "zxcvbn loaded");
        }
        window.zxcvbnLoading = false;
    };

    script.onerror = (err) => {
        devtricker_log(err, devtricker_log_level.ERROR, "zxcvbn failed to load");
        window.zxcvbnLoading = false;
    };

    document.head.appendChild(script);
};